import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type IModalComponentName =
  | 'about'
  | 'about-timesheet'
  | 'delete-timesheet'
  | 'confirm-abandon'
  | 'need-help'
  | 'simple-display';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  standalone: false,
})
export class ModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      component: IModalComponentName;
      data: any;
    },
    private readonly dialogRef: MatDialogRef<ModalComponent>,
  ) {}

  public ngOnInit(): void {
    this.dialogRef.backdropClick().subscribe(() => {
      this.handleClose(null);
    });
  }

  public handleClose(value?: any): void {
    this.dialogRef.close(value);
  }
}
